module.exports = __webpack_public_path__ + "static/img/digitalpeople2.205d078b.png";